import Icon, { CaretDownOutlined, LogoutOutlined } from "@ant-design/icons";
import { Avatar, Badge, Button, Drawer, Layout, Menu } from "antd";
import React, { Fragment } from "react";
import {
  BuildAndReleaseSchema,
  UserNotification,
} from "../helpers/shared-interfaces";
import "../styles/components/Navbar.css";
import GlobalSearch from "./GlobalSearch";

const { Item: MenuItem, SubMenu } = Menu;
const { Header } = Layout;

interface Props {
  children?: React.ReactNode;
  title?: string;
  username?: string;
  department?: string;
  role?: string;
  isOpen?: boolean;
  collapsed?: boolean;
  toggle?: () => void;
  logout?: () => void;
  userNotifications?: UserNotification[];
  releaseInfo: BuildAndReleaseSchema | null;
}

interface State {
  notifications: UserNotification[];
  visible: boolean;
}

class NavBar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      notifications: [],
      visible: false,
    };
    this.displayNotificationsCount = this.displayNotificationsCount.bind(this);
  }

  updateNotifications(): void {
    let allNotifications = this.props.userNotifications;
    const { notifications } = this.state;
    allNotifications = allNotifications ? allNotifications : notifications;
    this.setState({
      notifications: allNotifications,
    });
  }

  showDrawer = (): void => {
    this.setState({ visible: true });
  };
  onClose = (): void => {
    this.setState({ visible: false });
  };

  displayNotificationsCount(): JSX.Element {
    return (
      <SubMenu
        key="display-notifications"
        title={
          <Button onClick={this.showDrawer}>
            Notifications
            <Badge dot={true}>
              <Icon type="bell" />
            </Badge>
          </Button>
        }
      ></SubMenu>
    );
  }

  releaseInfoDropdown(releaseInfo: BuildAndReleaseSchema): JSX.Element {
    return (
      <SubMenu
        key={releaseInfo.apiVersion}
        title={
          <div>
            <span
              style={{
                marginRight: "15px",
              }}
            >
              API VERSION - {<b>{releaseInfo.apiVersion}</b>} |
            </span>
            <span
              style={{
                marginRight: "15px",
              }}
            >
              WEB VERSION - {<b>{releaseInfo.webVersion}</b>} |
            </span>
            <span>ENV - {<b>{releaseInfo.environment.toUpperCase()}</b>}</span>
          </div>
        }
      ></SubMenu>
    );
  }

  notificationsDrawer(): JSX.Element {
    const { notifications, visible } = this.state;
    return (
      <Drawer
        title="Notifications"
        placement="right"
        closable={true}
        onClose={this.onClose}
        visible={visible}
        width={350}
      >
        {notifications.map((notification: UserNotification): JSX.Element => {
          const date = new Date(notification.createdAt).toDateString();

          return (
            <div
              style={{
                padding: "5px",
                marginBottom: "5px",
                boxShadow: "0px 0px 2px black",
              }}
              key={notification.id}
            >
              <p>{notification.message}</p>
              <span
                style={{
                  position: "relative",
                  top: "-10px",
                  fontSize: "12px",
                }}
              >
                {date}
              </span>
            </div>
          );
        })}
      </Drawer>
    );
  }

  componentDidMount(): void {
    this.updateNotifications();
  }

  render(): JSX.Element | null {
    const { releaseInfo } = this.props;
    return (
      <Fragment>
        {this.notificationsDrawer()}
        <Header
          className="nav"
          style={{
            backgroundColor: "rgb(240, 242, 245)",
            position: "relative",
          }}
        >
          <span />
          <GlobalSearch />
          <Menu
            mode="horizontal"
            disabledOverflow
            style={{
              backgroundColor: "#f0f2f5",
              borderBottom: "none",
              textAlign: "right",
              lineHeight: "64px",
              height: "64px",
            }}
          >
            {releaseInfo && this.releaseInfoDropdown(releaseInfo)}
            {/* {this.displayNotificationsCount()} */}

            <SubMenu
              key="avatar"
              title={
                <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "black" }}>
                  <Avatar size="small" style={{ backgroundColor: "green", fontSize: 13 }}>
                    {this.props.username?.charAt(0).toUpperCase()}
                  </Avatar>
                  <span style={{ fontWeight: 500, color: "#888" }}>{this.props.username}</span>
                  <CaretDownOutlined style={{ fontSize: "11px", color: "#888" }} />
                </span>
              }
              className="sub-menu"
            >
              <MenuItem
                key="user-info"
                disabled
                style={{
                  cursor: "default",
                  borderBottom: "1px solid #f0f0f0",
                  minWidth: 200,
                  height: "auto",
                  lineHeight: "normal",
                  padding: "12px 16px",
                }}
              >
                {this.props.role && (
                  <div style={{ color: "#595959", fontSize: 13, fontWeight: 500 }}>{this.props.role}</div>
                )}
                {this.props.department && (
                  <div style={{ color: "#888", fontSize: 12, marginTop: 2 }}>{this.props.department}</div>
                )}
              </MenuItem>
              <MenuItem key="logout" onClick={this.props.logout} style={{ color: "#ff4d4f", marginTop: 4 }}>
                <LogoutOutlined />
                Logout
              </MenuItem>
            </SubMenu>
          </Menu>
        </Header>
      </Fragment>
    );
  }
}

export default NavBar;
